/**
 HeaderWrapper so that we can specify logos in the header
 Should the wb-header be updated so that it is possible there, we should use it instead
 */

import React from 'react'
import cn from 'classnames'
import './header.scss'
import { useTranslation } from 'react-i18next'
import classes from './HeaderWrapper.module.scss'
import { ReactComponent as Logo } from 'assets/MB-Rent-logo-einzeilig_neg.svg'
import { Link } from 'react-router-dom'
import { LanguageChange, LanguageDropdown } from '../../LanguageChange'
import i18n from 'i18next'

interface HeaderWrapperProps {
  logoHref?: string
  children: React.ReactNode
  className?: string
}

export const HeaderWrapper: React.FunctionComponent<HeaderWrapperProps> = ({
  logoHref,
  children,
  className,
}) => {
  const { t } = useTranslation()

  return (
    <div role="banner" className={cn('wb-header', className)}>
      <div className="wb-header__content-width">
        <div className="wb-header__logo-container">
          <a className="wb-header__logo" href={logoHref}>
            <Logo className={classes.logo} title="Mercedes-Benz Rent" />
          </a>
          <div className="wb-header__language">
            <div className={classes.desktop}>
              <LanguageChange />
            </div>
            <div className={classes.mobile}>
              <LanguageDropdown language={i18n.language} />
            </div>
            <Link
              to="/logout"
              className="wb-nav__control wb-nav__control--offset-right"
            >
              {t('components.header.header.logout')}
            </Link>
          </div>
        </div>
        <div className="wb-header__nav-container" role="navigation">
          {children}
        </div>
        <div className="wb-header__nav-container-mobile" role="navigation">
          {children}
        </div>
      </div>
    </div>
  )
}
